import { z } from 'zod';

export const AggLevelSchema = z.object({
    timestamp: z.string(),
    percentageRemainingAvg: z.number().nullable(),
    volumeRemainingAvg: z.number().nullable(), // metres cubed
});
